<template>
  <!-- <el-drawer :with-header="false" :visible.sync="show" direction="ltr" :before-close="handleClose"> -->
  <div>
    <Logo />
    <DrawNav />
  </div>
  <!-- </el-drawer> -->
</template>
<script >
import DrawNav from './components/draw-nav.vue';
import Logo from '../logo.vue';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  return {};
};
__sfc_main.components = Object.assign({
  Logo,
  DrawNav
}, __sfc_main.components);
export default __sfc_main;
</script>
<style scoped lang="scss"></style>
